import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetVideoUploadURLInterface {
  fileName: string;
  fileType: string;
}

export const useGetVideoUploadURL = () => {
  const mutate = useMutation(({ fileName, fileType }: GetVideoUploadURLInterface) => {
    return postAPI('/media-api/get_upload_url', {
      fileName,
      fileType,
    });
  });

  return mutate;
};

export default useGetVideoUploadURL;
